import type { ID, SellableType } from '@nutralab/api';

import { getOfferPath } from './getOfferPath';

/** The page of a catalog item, or `null` when it has none (bundles have no page yet). */
// TODO(backlog): links to the bundle page
export function getCatalogItemPath(item: { type: SellableType; id: ID; slug?: string | null }): string | null {
    return item.type === 'offer' ? getOfferPath(item) : null;
}
